module.exports = __webpack_public_path__ + "../resources/images/accessError-3d31b95d5c3fae62b2b33bd8fb5bfaf6.svg";